import { useAuthContext } from "modules/auth/AuthProvider";

export function useAuth() {
  return useAuthContext();
}
